import { Outlet } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider } from '@mui/material';
import { theme } from 'src/theme';
import ClientProvider from './ClientProvider';
import { LicenseInfo } from '@mui/x-license';
import { environment } from 'src/environment/environment';

LicenseInfo.setLicenseKey(environment.muiLicenseKey);

const Root = () => {
  return (
    <ClientProvider>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Outlet />
        </LocalizationProvider>
      </ThemeProvider>
    </ClientProvider>
  );
};

export default Root;
